<template>
  <div class="order-item">
    <div class="shop-con">
      <div class="shop-img-con"><img class="shop-img" :src="item.shopAvatar" alt=""></div>
      <div class="shop-name">{{ item.shopName }}</div>
      <div class="state">
        <span class="state-text" style="color: rgb(247,77,77);" v-if="item.orderStatus==='WAIT'">待付款</span>
        <span class="state-text" v-if="item.orderStatus==='PAID'">待收货</span>
        <span class="state-text" v-if="item.orderStatus==='FINISH'">已完成</span>
        <span class="state-text" v-if="item.orderStatus==='CANCELLED'">已取消</span>
        <span class="state-text" v-if="item.orderStatus==='TIMEOUT'">已超时</span>

      </div>
    </div>
    <div class="order-body">
      <div class="only-one" v-if="item.goodsList.length===1" @click="goSgOrderDetail">
        <div class="img-con">
          <img class="img" :src="'http://img13.360buyimg.com/n2/' + item.goodsList[0].goodsImage" alt="">
        </div>
        <div class="info-con">
          <div class="title">{{ item.goodsList[0].goodsName }}</div>
          <div class="total">
            <span class="now-price">￥{{ item.goodsList[0].unitAmount.toFixed(2) }}</span>
            <s class="old-price">原价:￥{{ item.goodsList[0].originalPrice.toFixed(2) }}</s>
            <span class="num">x{{ item.goodsList[0].goodsCount }}</span>
          </div>
        </div>
      </div>
      <div class="no-only-one" v-if="item.goodsList.length>1" @click="goSgOrderDetail">
        <div class="img-con">
          <div class="img-list">
            <div class="img-con-item" v-for="(item2, i2) in item.goodsList" :key="i2">
              <img class="img" :src="'http://img13.360buyimg.com/n2/'+item2.goodsImage" alt="">
            </div>
          </div>
        </div>
        <div class="total-con">
          <div class="total-price">￥{{ item.totalAmount.toFixed(2) }}</div>
          <div class="total-num">共{{ item.allCount }}件</div>
        </div>
      </div>
    </div>
    <div class="btn-con">
      <div class="btn" v-if="item.orderStatus==='WAIT'" @click="cancelOrder">取消订单</div>
      <div class="btn go-pay" v-if="item.orderStatus==='WAIT'" @click="goPay">去支付</div>


      <!--<div class="btn go-evaluated" v-if="item.orderStatus==='FINISH'&&item.isEvaluated===false" @click="goEvaluated">立即评价</div>-->
      <div class="btn buy-again" v-if="item.orderStatus==='CANCELLED'||item.orderStatus==='FINISH'||item.orderStatus==='TIMEOUT'" @click="gobuyAgain">再次购买</div>
      <div class="btn" v-if="item.orderStatus==='PAID'" @click="goSgOrderTrack(item)">查看物流</div>
      <div class="btn" v-if="false">申请发票</div>
      <div class="btn repurchase" v-if="false">申请发票</div>
    </div>



  </div>
</template>

<script>
import { cancelOrder, deliveryList } from '@/api/mall/mallOrder'
// import { getJDOrderTrack } from '@/api/mall/mallJD'
export default {
  props: {
    itemData: {
      required: true,
    }
  },
  data(){
    return {
      item: {}
    }
  },
  watch: {
    itemData: {
      handler(val){
        this.item = val
      },
      immediate: true
    }
  },
  created(){
    // console.log()
  },
  methods: {
    goSgOrderDetail(){
      this.$router.push({name: 'sgOrderDetail', query: {orderMergeId: this.item.orderMergeId}})
    },

    //去支付
    goPay(){
      let obj = {
        orderId: this.item.orderMergeId,
        orderNo: this.item.payOrderNo,
        totalAmount: this.item.totalAmount
      }
      this.session('sgConfirmOrderPay', obj)
      console.log(obj)
      this.$router.push({name: 'sgConfirmOrderPay'})
    },

    //评论页
    goEvaluated(){
      let list = this.item.goodsList.map(item=>{
        return {
          shopId: item.shopId,
          goodsId: item.goodsId,
          goodsName: item.goodsName,
          goodsImage: item.goodsImage,
          goodsType: item.goodsType,
          orderMergeId: this.item.orderMergeId
        }
      })
      this.session('evaluatedGoods', list)
      this.$router.push({name: 'sgOrderEvaluated'})
    },

    //再次购买
    gobuyAgain(){
      let list = this.itemData.goodsList
      let data = {items: []};
      list.map(item=>{
        data.items.push({
          goodsId: item.goodsId,
          goodsType: item.goodsType,
          priceWhenAdded: item.unitAmount,
          productCode: item.productCode,
          productCount: item.goodsCount,
          productId: item.productId,
          shopId: item.shopId,
          shopSysType: item.shopSysType
        })
      })
      this.$store.dispatch('sg/addBuyCart', data).then(()=>{
        this.$router.push({name: 'shoppingCart'})
      })
    },

    //取消订单
    cancelOrder(){
      console.log(this.item.payOrderNo)
      this.$dialog.confirm({
        message: '您确认要取消该订单吗？'
      }).then(() => {
        cancelOrder({orderNo: this.item.payOrderNo}).then(res=>{
          if(res.code===200){
            console.log('订单取消成功！')
            this.$emit('reloadList')
          }
        })
      }).catch(() => {

      })
    },

    // 获取物流包裹信息
    deliveryList(orderMergeId){

    },
    // 获取物流配送信息 //跳转至物流详情
    goSgOrderTrack(item){
      console.log(item)
      deliveryList({orderMergeId: item.orderMergeId}).then(res=>{
        let data = res.data || []
        let packageList = []
        if(data.length){
          data.map(item=>{
            packageList.push(item)
          })
          this.$router.push({name: 'sgOrderTrack', query: {jdOrderId: packageList[0].deliveryOrderId}})
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>
.order-item{
  font-size: 14px;background-color: #fff;margin-bottom: 10px;
  .shop-con{
    display: flex;width: 100%;height: 50px;border-bottom: 1px solid #edecec;
    .shop-img-con{
      width: 52px;height: 100%;display: inline-flex;justify-content: center;align-items: center;
      .shop-img{
        display: block;width: 30px;height: 30px;border-radius: 50%;
      }
    }
    .shop-name{
      flex: 1;height: 100%;display: inline-flex;justify-content: flex-start;align-items: center;color: #2b2b2b;
    }
    .state{
      display: inline-flex;width: 80px;height: 100%;
      justify-content: center;align-items: center;
      .state-text{
        color: #666;
      }
    }
  }
  .order-body{
    width: 100%;height: 115px;border-bottom: 1px solid #edecec;
    .only-one{
      padding: 15px 12px;
      display: flex;
      .img-con{
        display: inline-flex;justify-content: center;align-items: center;
        width: 85px;height: 100%;
        .img{width: 85px;height: 85px;border-radius: 8px;}
      }
      .info-con{
        display: inline-flex;flex-direction: column;justify-content: space-between;
        flex: 1;padding: 5px 0 5px 6px;
        .title{
          width: 100%;height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .total{
          width: 100%;
          display: flex;justify-content: flex-end;align-items: flex-end;font-size: 14px;
          .now-price{color: #f74d4d;margin-right: 10px;}
          .old-price{color: #999;margin-right: 10px;font-size: 10px;}
          .num{color: #666;margin-left: auto;margin-right: 0;}
        }
      }
    }
    .no-only-one{
      padding: 15px 12px;
      display: flex;position: relative;
      .img-con{
        width: 263px;height: 85px;overflow: hidden;
        position: relative;z-index: 0;
        .img-list{
          position: absolute;z-index: 0;display: flex;
          top: 0;left: 0;right: 0;bottom: -12px;
          overflow-y: hidden;overflow-x: auto;
          .img-con-item{
            display: inline-flex;
            width: 85px;height: 85px;margin-right: 10px;
            flex-grow:0;flex-shrink:0;
            .img{width: 100%;height: 100%;display: block;border-radius: 8px;}
          }
        }
      }
      .total-con{
        width: 100px;height: 100%;
        position: absolute;z-index: 1;
        top: 0;bottom: 0;right: 0;
        padding-right: 13px;
        display: flex;justify-content: center;align-items: flex-end;flex-direction: column;
        .total-price{color: #f74d4d;font-size: 14px;}
        .total-num{color: #666;font-size: 11px;}
      }
    }
  }
  .btn-con{
    width: 100%;height: 50px;overflow-x: auto;
    display: flex;justify-content: flex-end;align-items: center;
    .btn{
      margin-right: 12px;padding: 8px 12px;font-size: 14px;color: #666;
      border-radius: 18px;border: 1px solid #666;flex-grow:0;flex-shrink:0;
      display: inline-flex;flex-grow:0;flex-shrink:0;
      &.go-evaluated{color: #f74d4d;border-color: #f74d4d;}
      &.go-pay{color: #f74d4d;border-color: #f74d4d;}
      &.buy-again{color: #ff831b;border-color: #ff831b;}
      &.repurchase{color: #ff831b;border-color: #ff831b;}
    }
  }
}
</style>